import React from "react";
import { ContentBlock } from "@/types/case-study";

interface VideoBlockProps {
  block: ContentBlock;
}

export const VideoBlock: React.FC<VideoBlockProps> = ({ block }) => {
  const videoUrl = block.content?.url;
  const caption = block.content?.caption || "";

  return (
    <div className="space-y-3">
      <div className="w-full bg-gray-100 rounded-xl overflow-hidden border p-12">
        <video
          src={videoUrl}
          controls
          className="w-full rounded-lg h-auto max-h-96 object-contain shadow-[0_0_14px_-3px_rgba(15,23,42,0.16)]"
        >
          Your browser does not support the video tag.
        </video>
      </div>
      {caption && (
        <p className="text-sm text-gray-600 text-center italic">
          {caption}
        </p>
      )}
    </div>
  );
};